import { FC, useState } from "react";
import { IWidgetTemplate } from "../../../interfaces/widget-template";
import logo from "../../../assets/images/trustfinance-logo.svg";
import { useEffect } from "react";
import { CardBody, CardHeader } from "reactstrap";

import moment from "moment";
import { ReachClick } from "../../../utils/core";
import { fnRatingDisplay } from "../../../components/rateDisplay";
import StarRate from "../../../components/StarRate";
import { getReviewByCompanyIdApi } from "../../../apis/company";
import { Datum } from "../../../interfaces/review";
const WidgetTemplate4: FC<IWidgetTemplate> = ({ company, score, theme }) => {
  const [isFiltered, setIsFiltered] = useState("Positive");
  const [isReviews, setIsReviews] = useState<Datum[]>();
  const payload = {
    companyId: company?.companyId,
    widgetId: 4,
  };

  const getCompanyReviewById = async (
    id: string,
    order?: string
  ): Promise<void> => {
    try {
      const { data } = await getReviewByCompanyIdApi(id, order);

      setIsReviews(data?.data);
    } catch (e: any) {
      throw e;
    }
  };

  useEffect(() => {
    if (isFiltered === "Positive") {
      getCompanyReviewById(company?.companyId);
    } else {
      getCompanyReviewById(company?.companyId, "ASC");
    }
  }, [company?.companyId, isFiltered]);

  return (
    <div className="container">
      <div className="mt-4 ">
        <div>
          <CardHeader
            className={`p-2 rounded d-flex align-items-center flex-column ${
              theme === "dark" ? "bg-dark text-white" : "bg-white"
            }`}
          >
            <div className={`d-flex`}>
              <h4 className="me-2">{fnRatingDisplay(score?.score)}</h4>
              <StarRate value={score?.score} size={24} />
            </div>
            <div className={`d-flex`}>
              <div className="my-2">
                based on{" "}
                <a
                  style={{ color: "unset" }}
                  href={`https://www.trustfinance.com/companies/${company?.companyId}?utm_source=widget&utm_medium=banner&utm_campaign=list-filtered`}
                  target="_blank"
                  rel="noreferrer noopener"
                  onClick={() => ReachClick(payload)}
                >
                  {score?.totalReview} reviews
                </a>
              </div>
              <div className="d-flex align-items-center ms-2">
                <img src={logo} alt="" width={24} height={24} />
                <span
                  style={{ fontSize: 14, marginLeft: 4, fontWeight: "bold" }}
                >
                  TrustFinance
                </span>
              </div>
            </div>
            <div>
              <button
                className={`btn btn-outline-primary me-2 ${
                  isFiltered === "Positive" && "active"
                }`}
                onClick={() => setIsFiltered("Positive")}
              >
                Positive
              </button>
              <button
                className={`btn btn-outline-primary ${
                  isFiltered === "Negative" && "active"
                }`}
                onClick={() => setIsFiltered("Negative")}
              >
                Negative
              </button>{" "}
            </div>
          </CardHeader>
          <CardBody>
            <p className={`${theme === "dark" ? "text-white" : ""}`}>
              Showing our latest reviews
            </p>

            {isReviews?.map((item, i) => (
              <div
                key={i}
                className={`p-3 my-2 rounded ${
                  theme === "dark" ? "text-white bg-dark" : ""
                }`}
              >
                <StarRate value={item.score} size={18} />
                <h5 className="mt-2">{item.title}</h5>
                <p className="fs-12 mb-2">{item.description}</p>
                <div className="d-flex">
                  <span className="fs-12 fw-bold line-clamp-1 text-nowrap">
                    {item.user?.displayName}
                  </span>
                  <div
                    className={`fs-12 text-nowrap  ${
                      theme === "dark" ? "text-secondary" : "text-black-50"
                    }`}
                  >
                    ,&nbsp;
                    {moment(item.createdAt).fromNow()}
                  </div>
                </div>
              </div>
            ))}
          </CardBody>
        </div>
      </div>
    </div>
  );
};

export default WidgetTemplate4;
